// extracted by mini-css-extract-plugin
module.exports = {"BigButton":"BigButton_BigButton__1x8zN","Disabled":"BigButton_Disabled__-ycGf","Grad":"BigButton_Grad__20z_M","bgMove":"BigButton_bgMove__pEv2a"};